import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Main from '@/views/index'
import authUtis from '../utils/authUtis'
import crmRoutes from './crm'
import orderRoutes from './order'
import qcRoutes from './qc'
import autofillform from './autofillform'
import entityExtractRoutes from './entity-extract'
// import { userRoutes, channelRoutes, systemRoutes, aiRoutes } from './bp'
import { userRoutes, channelRoutes, systemRoutes } from './bp'
import globalVaribale from '@/utils/globalVariable'
import DevModule from 'xiaoi-aicc-dev'
import envUtils from '@/utils/envUtils'
const builtinAdminId = globalVaribale.defaultBuiltinAdminId
const workBenchUrl = envUtils('VUE_APP_WB_URL')
const isStandalone = envUtils('VUE_APP_STANDALONE')
const baseUrl = envUtils('VUE_APP_BASE_URL')

Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/* adminRoutes 对admin使用，勿修改勿新增 */
const adminRoutes = [
  {
    path: '/user',
    redirect: '/user/wbmgr',
    name: 'bp.sidebar_auth',
    icon: 'iconmeneicon-yonghu',
    children: userRoutes,
    component: () => import('@/views/auth')
  }, {
    path: '/system',
    redirect: '/system/custom_field',
    name: 'bp.sidebar_sys',
    icon: 'iconmenuicon-xitong',
    children: systemRoutes,
    component: () => import('@/views/system')
  }
]

export const rootRoutes = [
  {
    path: '/overview',
    name: 'workbench.sidebar_overview',
    icon: 'iconrenwugailan',
    meta: {
    },
    component: () => import('@/views/overview')
  },
  // {
  //   path: '/chat',
  //   name: 'workbench.sidebar_chat',
  //   icon: 'iconmenu-huihua',
  //   meta: {
  //     keepAlive: true
  //   },
  //   component: () => import('@/views/chat')
  // },
  {
    path: '/chatlog',
    name: 'workbench.sidebar_chatlog',
    icon: 'iconmanu-bianji',
    meta: {
      keepAlive: true
    },
    component: () => import('@/views/chatlog')
  },
  {
    path: '/leaveword',
    name: 'workbench.sidebar_leaveword',
    icon: 'iconfangkeliuyan',
    meta: {
      keepAlive: true
    },
    component: () => import('@/views/leaveword')
  },
  {
    path: '/watch',
    name: 'workbench.sidebar_watch',
    icon: 'iconzhuguanjiankong',
    meta: {
    },
    component: () => import('@/views/watch')
  },
  {
    path: '/chatHistory',
    name: 'ChatHistory',
    hide: true,
    // icon: 'iconmenu-huihua',
    meta: {
    },
    component: () => import('@/views/chatlog/ChatHistory')
  },
  {
    path: '/workorder',
    name: 'workbench.sidebar_workorder',
    icon: 'iconmenu-gongdan',
    meta: {
    },
    component: () => import('@/views/workorder'),
    children: [
      {
        path: '/workorder/finished',
        name: 'finished',
        icon: 'iconmenu-huihua',
        meta: {
        },
        component: () => import('@/views/workorder/OrderList')
      },
      {
        path: '/workorder/processing',
        name: 'processing',
        icon: 'iconmenu-huihua',
        meta: {
        },
        component: () => import('@/views/workorder/OrderList')
      },
      {
        path: '/workorder/replied',
        name: 'replied',
        icon: 'iconmenu-huihua',
        meta: {
        },
        component: () => import('@/views/workorder/OrderList')
      },
      {
        path: '/workorder/processed',
        name: 'processed',
        icon: 'iconmenu-huihua',
        meta: {
        },
        component: () => import('@/views/workorder/OrderList')
      },
      {
        path: '/workorder/listTemplate',
        name: 'listTemplate',
        icon: 'iconmenu-huihua',
        meta: {
        },
        component: () => import('@/views/workorder/TemplateList')
      }
    ]
  },
  {
    path: '/workreport',
    name: 'workbench.sidebar_workreport',
    icon: 'iconmenu-baobiao',
    meta: {
      keepAlive: true
    },
    component: () => import('@/views/workreport'),
    children: [
      {
        path: '/workreport/dataReport/kpi',
        name: 'KPI统计',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/workreport/kpi/Detail'),
        children: [
          {
            path: '/workreport/dataReport/kpi/detail',
            name: 'KPI详情',
            meta: {
              keepAlive: true
            },
            component: () => import('@/views/workreport/kpi/Detail')
          }
        ]
      }, {
        path: '/workreport/dataReport/performance',
        name: '绩效分析',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/workreport/PerformAnalysis'),
        children: [
          {
            path: '/workreport/dataReport/performance/workHoursStatistics',
            name: '工作时长统计',
            meta: {
              keepAlive: true
            },
            component: () => import('@/views/workreport/components/performance/WorkHoursStatistics')
          }
        ]
      }, {
        path: '/workreport/dataReport/analyze',
        name: '数据分析',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/workreport/queue'),
        children: [
          {
            path: '/workreport/dataReport/analyze/evaluation',
            name: '咨询评价分析',
            meta: {
              keepAlive: true
            },
            component: () => import('@/views/workreport/SeatReport')
          }, {
            path: '/workreport/queue',
            name: '访客排队分析',
            meta: {
              keepAlive: true
            },
            component: () => import('@/views/workreport/queue/analyze/QueueAnalyze')
          }
        ]
      }
    ]
  },
  {
    path: '/setting',
    name: 'workbench.sidebar_setting',
    icon: 'iconmenu-gerenshezhi',
    meta: {
    },
    component: () => import('@/views/setting'),
    children: [
      {
        path: '/setting/basic',
        name: '基本设置',
        meta: {
        },
        component: () => import('@/views/setting/Basic')
      }, {
        path: '/setting/shortcutKey',
        name: '快捷设置',
        meta: {
        },
        component: () => import('@/views/setting/shortcutKey')
      }, {
        path: '/setting/replyQuickly',
        name: '快捷回复设置',
        meta: {
        },
        component: () => import('@/views/setting/ReplyQuickly')
      }
    ]
  },
  {
    path: '/user',
    name: 'bp.sidebar_auth',
    icon: 'iconmeneicon-yonghu',
    children: userRoutes,
    component: () => import('@/views/auth')
  }, {
    path: '/channel',
    name: '渠道',
    icon: 'iconmenuicon-qudao',
    children: channelRoutes,
    component: () => import('@/views/channel')
  }, {
    path: '/system',
    name: 'bp.sidebar_sys',
    icon: 'iconmenuicon-xitong',
    children: systemRoutes,
    component: () => import('@/views/system')
  }, {
    path: '/crm',
    name: 'bp.sidebar_crm',
    icon: 'iconmenuicon-kehu',
    children: crmRoutes,
    component: () => import('@/views/crm')
  }, {
    path: '/order',
    // redirect: '/order/client_mgr',
    name: 'bp.sidebar_order',
    icon: 'iconmenuicon-gongdan',
    children: orderRoutes,
    component: () => import('@/views/order')
  }, {
    path: '/qc',
    redirect: '/qc/newModel/newModel_menu',
    name: 'qc.qc_title',
    icon: 'iconmenuicon-kehu',
    children: qcRoutes,
    component: () => import('@/views/qc')
  }, {
    path: '/autofillform',
    redirect: '/autofillform/createAutofillform',
    name: '填单',
    icon: 'iconmenuicon-kehu',
    children: autofillform,
    component: () => import('@/views/autofillform')
  }, {
    path: '/entity',
    redirect: '/entity/custom/tag',
    name: '实体',
    icon: 'iconmenuicon-kehu',
    children: entityExtractRoutes,
    component: () => import('@/views/entity')
  }
  // , {
  //   path: '/crm',
  //   name: 'bp.sidebar_crm',
  //   icon: 'iconmenuicon-kehu',
  //   children: crmRoutes,
  //   component: () => import('@/views/crm')
  // }
]

const routes = [
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login')
  },
  {
    path: '/loginHelp',
    name: 'loginHelp',
    hidden: true,
    component: () => import('@/views/login/loginHelp')
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    hidden: true,
    component: () => import('@/views/login/forgetPassword')
  }
]

/* export const router = () => new VueRouter({
  mode: 'hash',
  base: baseUrl,
  routes
}) */
const createRouter = () => {
  return new VueRouter({
    mode: 'hash',
    base: baseUrl,
    routes
  })
}
export const router = createRouter()
function deepClone(obj) {
  const t = new obj.constructor()
  if (obj instanceof Date) return new Date(obj)
  if (obj instanceof RegExp) return new RegExp(obj)
  if (typeof obj !== 'object') return obj
  for (const key in obj) {
    t[key] = deepClone(obj[key])
  }
  return t
}

function compareDevModule() {
  return function (a, b) {
    return a.idx - b.idx
  }
}

// function matchRoute(routes, route, parentPath = '') {
//   for (let i = 0; i < routes.length; i++) {
//     if (parentPath + routes[i].path === route.path || routes[i].path === route.path) {
//       return true
//     } else if (routes[i].path.indexOf(parentPath) === 0 && routes[i].path === route.path) {
//       return true
//     } else if (routes[i].children) {
//       while (matchRoute(routes[i].children, route, parentPath + routes[i].path + '/')) {
//         return true
//       }
//     }
//   }
//   return false
// }

// function getQueryString(name) {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
//   var r = decodeURI(window.location.search.substr(1)).match(reg)
//   if (r != null) return unescape(r[2])
//   return null
// }

// function navToChat(routes) {
//   if (matchRoute(routes, { path: '/chat' })) {
//     const s = localStorage.getItem('WORK-STATUS')
//     if (s && s === 'online') {
//       return true
//     }
//   }
//   return false
// }

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = decodeURI(window.location.search.substr(1)).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/loginHelp' || to.path === '/forgetPassword') {
    localStorage.clear()
    // setTimeout(() => {
    //   window.location.href = workBenchUrl
    // }, 2000)
    next()
  } else if (to.path === '/404') {
    next()
  } else {
    let token = getQueryString('token')
    if (token) {
      token = decodeURIComponent(token)
    }
    // let token = localStorage.getItem('Authorization')
    // if (!token || token === 'null' || token === '') {
    //   token = getQueryString('token')
    //   if (token) {
    //     token = decodeURIComponent(token)
    //   }
    // }
    if (!token || token === 'null' || token === '') {
      next('/login')
    } else {
      store.commit('user/setToken', { token: token })
      if (isStandalone === 'false') {
        let tenantId = localStorage.getItem('X-TENANT-ID')
        if (process.env.NODE_ENV === 'development') {
          tenantId = getQueryString('tenantId')
        }
        store.commit('user/setTenantId', tenantId)
      }
      if (store.state.user.authRoutes.length === 0) {
        store.dispatch('user/getUser').then(res => {
          let list = []
          const rootRoutesCopy = deepClone(rootRoutes)
          const _res = JSON.parse(JSON.stringify(res))
          if (res && res.length !== 0) {
            const loginUserId = store.state.user.loginUser.userId
            if (builtinAdminId === loginUserId) {
              list = adminRoutes
            } else {
              if (isStandalone === 'false') {
                list.push({
                  path: '/home/template',
                  name: '首页',
                  icon: 'iconmenuicon-home',
                  children: [],
                  component: () => import('@/views/home/template')
                })
              }
              // 质检临时加权限
              /** 保证rootRoutesCopy顺序 */
              rootRoutesCopy.forEach((v1) => {
                _res.forEach((v2) => {
                  if (v2 instanceof Array) {
                    const tl = authUtis.geneRecuMenu(v1, v2)
                    list = list.concat(tl)
                  }
                })
              })
              // list.push({
              //   path: '/assist',
              //   redirect: '/assist',
              //   name: 'bp.sidebar_app',
              //   icon: 'iconmenuicon-xitong',
              //   children: assistRoutes,
              //   component: () => import('@/views/assist')
              // })
            }
            if (isStandalone === 'true' && (DevModule.bp && DevModule.bp.length > 0)) {
              DevModule.bp.sort(compareDevModule())
              DevModule.bp.forEach(item => {
                var one = {
                  path: '/dev' + item.path,
                  name: item.title,
                  icon: item.icon,
                  component: item.component
                }
                if (item.children && item.children.length > 0) {
                  var itemChild = []
                  item.children.forEach(eachChild => {
                    itemChild.push({
                      path: '/dev' + eachChild.path,
                      component: eachChild.component
                    })
                  })
                  one.children = itemChild
                }
                list.push(one)
              })
            }
            if (!list || !list.length) { // 如果非管理员，那么list为空，有token也要跳转到登录
              if (store.state.user.loginUser.roleType === '1') {
                next('/login')
              } else {
                window.location.replace(workBenchUrl +
                  '?token=' +
                  localStorage.getItem('Authorization') +
                  '&tenantId=' +
                  localStorage.getItem('X-TENANT-ID'))
              }
              return
            }
            // 设置redirect
            // list.forEach((v, i) => {
            //   if (v.children && v.children.length > 0) {
            //     v.redirect = v.children[0].path
            //   }
            // })
            authUtis.setRediectPath(list)
            store.commit('user/SET_ADMIN_ROUTES', { authRoutes: list })

            var addChilds = [{
              path: '/chatHistory',
              name: 'ChatHistory',
              hide: true,
              // icon: 'iconmenu-huihua',
              component: () => import('@/views/chatlog/ChatHistory')
            }]
            if (isStandalone === 'false') {
              addChilds.push({
                path: '/home/authentication',
                name: '认证',
                hide: true,
                component: () => import('@/views/home/template/Authentication')
              })
            }

            router.matcher = createRouter().matcher
            router.matcher.addRoutes(
              [{
                path: '/',
                component: Main,
                children: addChilds.concat(list)
              }, { path: '*', name: '404页面', component: () => import('@/views/error/404') }]
            )

            next({ ...to })
          }
        })
      } else {
        // 如果路由是/那么动态判断显示第一个可以显示的1级或2级路由
        // rootRoutes中的redirect配置暂时这样利用一下，可能由于权限因素也需要动态判断
        if (to.path === '/') {
          const r = store.state.user.authRoutes
          if (r && r.length && r.length > 0) {
            let path = r[0].path
            if (r[0].children && r[0].children.length > 0) {
              path = r[0].children[0].path
            }
            next(path)
            return
          }
        }
        next()
      }
    }
  }
})
